import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-how-it-works',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <section id="how-it-works" class="section how-it-works">
      <div class="container">
        <div class="section-header text-center">
          <h2 class="section-title">Comment ça marche ?</h2>
          <p class="section-subtitle">
            Rejoindre Zero-Waste est simple et rapide. Suivez ces trois étapes
            pour commencer à valoriser vos invendus dès aujourd'hui.
          </p>
        </div>

        <div class="steps">
          <div class="step">
            <div class="step-number">1</div>
            <div class="step-content">
              <div class="step-icon">
                <i class="fas fa-user-plus"></i>
              </div>
              <h3>Inscription en ligne</h3>
              <p>
                Créez votre compte commerçant en quelques minutes et configurez
                votre profil avec les informations de votre établissement.
              </p>
              <ul class="step-details">
                <li><i class="fas fa-check"></i> Formulaire simple</li>
                <li><i class="fas fa-check"></i> Vérification rapide</li>
                <li><i class="fas fa-check"></i> Assistance personnalisée</li>
              </ul>
            </div>
          </div>

          <div class="step">
            <div class="step-number">2</div>
            <div class="step-content">
              <div class="step-icon">
                <i class="fas fa-upload"></i>
              </div>
              <h3>Mise en ligne des invendus</h3>
              <p>
                Publiez facilement vos offres d'invendus sur notre plateforme en
                précisant le type de produits, la quantité et le prix.
              </p>
              <ul class="step-details">
                <li><i class="fas fa-check"></i> Interface intuitive</li>
                <li>
                  <i class="fas fa-check"></i> Gestion des stocks simplifiée
                </li>
                <li><i class="fas fa-check"></i> Planification automatique</li>
              </ul>
            </div>
          </div>

          <div class="step">
            <div class="step-number">3</div>
            <div class="step-content">
              <div class="step-icon">
                <i class="fas fa-shopping-bag"></i>
              </div>
              <h3>Clients récupèrent leurs paniers</h3>
              <p>
                Les clients réservent et viennent chercher leurs paniers
                directement dans votre établissement aux horaires que vous avez
                définis.
              </p>
              <ul class="step-details">
                <li><i class="fas fa-check"></i> Notifications automatiques</li>
                <li><i class="fas fa-check"></i> Système de QR code</li>
                <li><i class="fas fa-check"></i> Paiement sécurisé</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="text-center">
          <a
            [routerLink]="['/create-account']"
            class="btn-home btn-primary-home btn-large"
          >
            Commencer maintenant
          </a>
        </div>
      </div>
    </section>
  `,
  styles: [
    `
      .how-it-works {
        background-color: var(--gray-color);
        position: relative;
      }

      .steps {
        margin: 60px 0;
      }

      .step {
        display: flex;
        margin-bottom: 50px;
        position: relative;
        align-items: center;
      }

      .step:last-child {
        margin-bottom: 60px;
      }

      .step:not(:last-child)::after {
        content: '';
        position: absolute;
        top: 70px;
        left: 30px;
        width: 2px;
        height: calc(100% + 30px);
        background-color: var(--primary-light);
        z-index: 1;
      }

      .step-number {
        width: 60px;
        height: 60px;
        background-color: var(--primary-color);
        color: var(--light-color);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 1.5rem;
        font-weight: 700;
        margin-right: 30px;
        position: relative;
        z-index: 2;
        flex-shrink: 0;
      }

      .step-content {
        background-color: var(--light-color);
        border-radius: 15px;
        padding: 30px;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
        flex-grow: 1;
        text-align: center;
      }

      .step-icon {
        width: 60px;
        height: 60px;
        background-color: var(--secondary-color);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 20px;
        margin-left: auto;
        margin-right: auto;
      }

      .step-icon i {
        font-size: 1.5rem;
        color: var(--primary-color);
      }

      .step-content h3 {
        font-size: 1.5rem;
        margin-bottom: 15px;
      }

      .step-content p {
        color: var(--dark-gray);
        margin-bottom: 20px;
      }

      .step-details {
        list-style: none;
        padding-left: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .step-details li {
        margin-bottom: 10px;
        display: flex;
        align-items: center;
      }

      .step-details li i {
        color: var(--primary-color);
        margin-right: 10px;
      }

      @media (max-width: 768px) {
        .step {
          flex-direction: column;
        }

        .step-number {
          margin-right: 0;
          margin-bottom: 20px;
        }

        .step:not(:last-child)::after {
          left: 30px;
          top: 60px;
          height: calc(100% - 30px);
        }
      }

      .section-subtitle {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 3rem;
        font-size: 1.15rem;
        line-height: 1.7;
      }
    `,
  ],
})
export class HowItWorksComponent {}
